import { render, staticRenderFns } from "./RegisteredTurnover.vue?vue&type=template&id=f0f35e54&scoped=true"
import script from "./RegisteredTurnover.vue?vue&type=script&lang=js"
export * from "./RegisteredTurnover.vue?vue&type=script&lang=js"
import style0 from "./RegisteredTurnover.vue?vue&type=style&index=0&id=f0f35e54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f35e54",
  null
  
)

export default component.exports